import React, {useState} from "react";
import cx from 'classnames';
import {Space} from "antd";
import styles from './styles.module.less';

type TQueryTabs = {
  onChange: (status: '1'| '2') => void
}

const QueryTabs:React.FC<TQueryTabs> = ({onChange}) => {
  const [active, setActive] = useState(0);
  return (
    <Space className={styles.tab_wrapper}>
      <div className={cx(styles.tabs,active === 0 && styles.active)} onClick={() => {
        setActive(0);
        onChange('1');
      }}>全部</div>
      <div className={cx(styles.tabs,active === 1 && styles.active)} onClick={() => {
        setActive(1);
        onChange('2');
      }}>已通过</div>
    </Space>
  )
}
export default QueryTabs;
